import { css } from "styled-system/css";

export const container = css({
  position: "relative",
  display: "inline-block",
  width: "3rem",
  height: "1.5rem",
  verticalAlign: "middle",
  cursor: "pointer",
});

export const input = css({
  opacity: 0,
  width: 0,
  height: 0,
  margin: 0,
  position: "absolute",
});

export const track = css({
  position: "absolute",
  cursor: "pointer",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "bgBase300",
  transitionDuration: "0.4s",
  transitionProperty: "background-color",
  borderRadius: "full",
});

export const trackChecked = css({
  backgroundColor: "primary",
});

export const thumb = css({
  position: "absolute",
  height: "1.125rem",
  width: "1.125rem",
  left: "0.2rem",
  bottom: "0.1875rem",
  backgroundColor: "white",
  transitionDuration: "0.4s",
  transitionProperty: "transform",
  borderRadius: "50%",
  boxShadow: "0 1px 3px rgba(0,0,0,0.4)",
});

export const thumbChecked = css({
  transform: "translateX(1.5rem)",
});
